import * as actions from '../constants/CartActionTypes';

export const setCart = (payload) => ({ type: actions.SET_CART, payload });
export const updateCartItems = (payload) => ({ type: actions.UPDATE_CART_ITEMS, payload });

export const setCoupon = (payload) => ({ type: actions.SET_COUPON, payload });

export const setTotal = (payload) => ({ type: actions.SET_TOTAL_PRICE, payload });

export const setInstallments = (payload) => ({ type: actions.SET_INSTALLMENTS, payload });
export const resetCart = () => ({ type: actions.RESET_CART });

export const setRebate = (payload) => ({ type: actions.SET_REBATE, payload });
export const setBalance = (payload) => ({ type: actions.SET_BALANCE, payload });
export const setDeposit = (payload) => ({ type: actions.SET_DEPOSIT, payload });
export const setCredit = (payload) => ({ type: actions.SET_CREDIT, payload });